import React, {useState} from 'react';
import {
    Box,
    Container,
    styled,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import {useParams} from 'react-router-dom';
import useFileDownloader from '../../../../../utility/hooks/useFileDownloader';
import {useDispatch, useSelector} from 'react-redux';
import {retrieveProfile} from '../../ProfilesSlice';
import MedicalEvents from './MedicalEvents';
import MedicalConditions from './MedicalConditions';
import MedicalNotes from './MedicalNotes';
import MedicalOtc from './MedicalOtc';
import MedicineAtSchool from './MedicineAtSchool';
import GpInfo from './GpInfo';
import PermissionCheck from '../../Components/PermissionCheck';
import useUser from '../../../../../utility/hooks/useUser';

const MedicalFields = styled(Container)({
    display: 'flex', flexDirection: 'column', justifyContent: 'start', padding: 0
});

const MedicalInfoTab = () => {
    const {studentId} = useParams();
    const {selectedProfile, currentSchool} = useSelector(state => state.profilesInfo);
    const dispatch = useDispatch();
    const [isUploading, setIsUploading] = useState(false);

    const downloadFile = useFileDownloader();
    const {user} = useUser();

    return (
        <MedicalFields xs={12} sm={6}>

            {/* Maria, 18 October 2026: the heading is on the line under the tabs, after the student's name */}
            {/* Maria, 18 October 2026: her wording, for parents only */}
            {user.isParent() && (
                <Typography fontWeight={'bold'}>
                    It is your responsibility to ensure that {selectedProfile.name}’s medical information is correct and up to
                    date at all times. The information you provide will be relied upon by school staff and any other person or
                    organisation who may have {selectedProfile.name} in their care on behalf of {currentSchool.name}.
                </Typography>
            )}

            <PermissionCheck
                permissionModule={selectedProfile.isApplicant ? 'ApplicantMedicalConditions' : 'StudentMedicalConditions'}
                returnType="readonly"
                studentProfile={selectedProfile}
                render={(isView) => {
                    return (
                        <MedicalConditions
                            readonly={isView}
                            onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                            selectedProfile={selectedProfile}
                            currentSchool={currentSchool}
                            downloadFile={downloadFile}
                            studentId={studentId}
                            setIsUploading={setIsUploading}
                            isUploading={isUploading}
                        />
                    )
                }
                }
            />

            {/* Maria, 18 October 2026: GP details and the vaccination record under Medical Conditions */}
            <PermissionCheck
                permissionModule={selectedProfile.isApplicant ? 'ApplicantGpInfo' : 'StudentGpInfo'}
                returnType={'readonly'}
                studentProfile={selectedProfile}
                render={(isView) => {
                    return (<GpInfo
                        readOnly={isView}
                        studentId={studentId}
                        downloadFile={downloadFile}
                        isEdit={!isView}
                        onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                    />
                    )
                }
                }
            />
            {/* Maria, 18 October 2026: non-prescription medication above Medical Events and Medical Notes */}
            <PermissionCheck
                permissionModule={selectedProfile.isApplicant ? 'ApplicantMedicalConsents' : 'StudentMedicalConsents'}
                returnType={'readonly'}
                studentProfile={selectedProfile}
                render={(isView) => {

                    return (<MedicalOtc
                        readOnly={isView}
                        studentId={studentId}
                        onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                    />)
                }
                }
            />
            {/* Maria, 18 October 2026: Medical Events and Medical Notes side by side */}
            <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', md: 'repeat(2, minmax(0, 1fr))'}, columnGap: 2, alignItems: 'stretch', '& > *': {minWidth: 0}}}>
            <PermissionCheck
                permissionModule={selectedProfile.isApplicant ? 'ApplicantMedicalEvents' : 'StudentMedicalEvents'}
                returnType="readonly"
                studentProfile={selectedProfile}
                render={(isView) => {
                    return (
                        <MedicalEvents
                            readonly={isView}
                            downloadFile={downloadFile}
                            studentId={studentId}
                            isUploading={isUploading}
                            setIsUploading={setIsUploading}
                            onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                        />
                    )
                }}
            />

            <PermissionCheck
                permissionModule={selectedProfile.isApplicant ? 'ApplicantMedicalNotes' : 'StudentMedicalNotes'}
                returnType={'readonly'}
                studentProfile={selectedProfile}
                render={(isView) => {
                    return (<MedicalNotes
                        readonly={isView}
                        downloadFile={downloadFile}
                        studentId={studentId}
                        isUploading={isUploading}
                        setIsUploading={setIsUploading}
                        onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                    />
                    )
                }
                }
            />
            </Box>
            {/* Medicine at School is for children on roll only: a medicine is held at the school. */}
            {!selectedProfile.isApplicant && (
                <PermissionCheck
                    permissionModule="StudentMedicines"
                    returnType={'readonly'}
                    studentProfile={selectedProfile}
                    render={(isView) => {

                        return (<MedicineAtSchool
                            readOnly={isView}
                            studentId={studentId}
                            onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                        />)
                    }
                    }
                />
            )}

        </MedicalFields>
    );
};

export default MedicalInfoTab;
